import { withHandlers, withState } from 'recompose';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import renderNothing from 'recompose/renderNothing';
import clockInHandler from './clockInHandler';
import clockOutHander from './clockOutHandler';

import NavigationButton from '../components/NavigationButton';
import {
  isTimerActive,
  shouldShowClockInButton,
} from '../selectors';

const mapStateToProps = state => ({
  active: isTimerActive(state),
  display: shouldShowClockInButton(state),
});

const orNull = branch(
  props => !props.display,
  renderNothing,
);

export default compose(
  connect(mapStateToProps),
  orNull,
  clockInHandler,
  clockOutHander,
  withState('hover', 'setHover', false),
  withHandlers({
    onMouseIn: props => () => props.setHover(true),
    onMouseOut: props => () => props.setHover(false),
  })
)(NavigationButton);
